import type { ClearAlarmsResult } from '@ctcells/api'
import { errorMessage } from '@ctcells/i18n'

import type { BulkClearSummary } from './AlarmsScreen.tsx'

/**
 * 일괄 해제 결과 → 화면 요약. 🔴 까닭은 건별 오류의 사전 문구(`errorMessage` — `error_code` 기준)로 묶는다.
 * 같은 문구는 한 줄로 · 많은 것이 위.
 */
export function summarizeClearAll(result: ClearAlarmsResult): BulkClearSummary {
  const counts = new Map<string, number>()
  for (const { error } of result.failed) {
    const reason = errorMessage(error)
    counts.set(reason, (counts.get(reason) ?? 0) + 1)
  }
  return {
    cleared: result.cleared.length,
    failures: [...counts.entries()]
      .map(([reason, count]) => ({ reason, count }))
      .sort((a, b) => b.count - a.count),
  }
}
